import { useEffect } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { useMap } from "react-leaflet";

const propTypes = {
  position: PropTypes.oneOf([
    "bottomleft",
    "bottomright",
    "topleft",
    "topright",
  ]),
  children: PropTypes.node,
};

const MapControl = ({ position = "topright", children }) => {
  const map = useMap();

  const controlContainer = map._controlCorners[position];
  const controlWrapper = document.createElement("div");
  controlWrapper.classList.add("leaflet-control");

  useEffect(() => {
    controlContainer.insertBefore(controlWrapper, controlContainer.firstChild);

    return () => {
      controlContainer.removeChild(controlWrapper);
    };
  }, [controlWrapper, controlContainer]);

  return ReactDOM.createPortal(children, controlWrapper);
};

MapControl.propTypes = propTypes;

export default MapControl;
